import script from "./select-company-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./select-company-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__